<script>
export default {
  name: 'Overlay',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<template>
  <v-flex v-if="visible" class="tw-overlay"/>
</template>

<style lang="scss">
  .tw-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.65);
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/TwOverlay.vue